import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const YAMATO_80_RATES: [string, number][] = [
  ['関東・信越・北陸・中部・南東北（東京都・神奈川県・埼玉県・千葉県・茨城県・栃木県・群馬県・山梨県・新潟県・長野県・富山県・石川県・福井県・静岡県・愛知県・岐阜県・三重県・福島県・宮城県・山形県）', 1230],
  ['北東北・関西（岩手県・秋田県・青森県・大阪府・京都府・滋賀県・奈良県・和歌山県・兵庫県）', 1350],
  ['中国・四国（岡山県・広島県・鳥取県・島根県・山口県・香川県・徳島県・愛媛県・高知県）', 1480],
  ['九州・北海道（福岡県・佐賀県・長崎県・熊本県・大分県・宮崎県・鹿児島県・北海道）', 1740],
  ['沖縄県', 2070],
];

const YAMATO_60_RATES: [string, number][] = [
  ['関東・信越・北陸・中部・南東北（東京都・神奈川県・埼玉県・千葉県・茨城県・栃木県・群馬県・山梨県・新潟県・長野県・富山県・石川県・福井県・静岡県・愛知県・岐阜県・三重県・福島県・宮城県・山形県）', 940],
  ['北東北・関西（岩手県・秋田県・青森県・大阪府・京都府・滋賀県・奈良県・和歌山県・兵庫県）', 1060],
  ['中国・四国（岡山県・広島県・鳥取県・島根県・山口県・香川県・徳島県・愛媛県・高知県）', 1190],
  ['九州・北海道・沖縄県（福岡県・佐賀県・長崎県・熊本県・大分県・宮崎県・鹿児島県・北海道・沖縄県）', 1460],
];

export default function ShippingPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-16">
        <div className="bg-secondary-50 py-16 px-6 text-center">
          <p className="text-xs tracking-[0.3em] text-primary-500 mb-3 uppercase"
            style={{ fontFamily: "var(--font-heading)" }}>
            Shipping
          </p>
          <h1 className="text-4xl md:text-6xl font-light text-foreground-950"
            style={{ fontFamily: "var(--font-heading)" }}>
            配送について
          </h1>
        </div>

        <div className="max-w-3xl mx-auto px-6 py-14 space-y-12">
          <section>
            <h2 className="text-xl font-light text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
              送料区分について
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-2" style={{ fontFamily: "var(--font-body)" }}>
              ご注文内容によって、以下の3種類の配送方法・送料のいずれかが自動的に適用されます。同じご注文の中に複数の区分の商品が含まれる場合は、上から優先順位の高い方法が適用されます。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6" style={{ fontFamily: "var(--font-body)" }}>
              発送は、お支払い(銀行振込の場合はご入金)確認後7日以内を目安に行います。
            </p>
            <div className="space-y-4">
              <div className="border border-background-200 rounded-xl p-5">
                <p className="text-sm text-foreground-900 mb-1" style={{ fontFamily: "var(--font-heading)" }}>
                  1. トートバッグ、またはロフミスト+クリアファイル(もしくはトートバッグ)を含むご注文
                </p>
                <p className="text-sm text-foreground-600" style={{ fontFamily: "var(--font-body)" }}>
                  ヤマト便(80サイズ)でお届けします。送料は配送先の地域によって異なります(下記表を参照)。
                </p>
              </div>
              <div className="border border-background-200 rounded-xl p-5">
                <p className="text-sm text-foreground-900 mb-1" style={{ fontFamily: "var(--font-heading)" }}>
                  2. ロフミストを含むご注文(上記以外の組み合わせ)
                </p>
                <p className="text-sm text-foreground-600" style={{ fontFamily: "var(--font-body)" }}>
                  ヤマト便(60サイズ)でお届けします。送料は配送先の地域によって異なります(下記表を参照)。
                </p>
              </div>
              <div className="border border-background-200 rounded-xl p-5">
                <p className="text-sm text-foreground-900 mb-1" style={{ fontFamily: "var(--font-heading)" }}>
                  3. 上記以外のご注文
                </p>
                <p className="text-sm text-foreground-600" style={{ fontFamily: "var(--font-body)" }}>
                  日本郵便(クリックポスト)にて、全国一律240円でお届けします。
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-light text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
              ヤマト便 地域別送料(80サイズ)
            </h2>
            <div className="border border-background-200 rounded-xl overflow-hidden">
              <table className="w-full text-sm" style={{ fontFamily: "var(--font-body)" }}>
                <tbody>
                  {YAMATO_80_RATES.map(([area, price]) => (
                    <tr key={area} className="border-b border-background-200 last:border-b-0">
                      <td className="px-4 py-3 text-foreground-700">{area}</td>
                      <td className="px-4 py-3 text-foreground-950 text-right whitespace-nowrap" style={{ fontFamily: "var(--font-heading)" }}>
                        ¥{price.toLocaleString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-light text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
              ヤマト便 地域別送料(60サイズ)
            </h2>
            <div className="border border-background-200 rounded-xl overflow-hidden">
              <table className="w-full text-sm" style={{ fontFamily: "var(--font-body)" }}>
                <tbody>
                  {YAMATO_60_RATES.map(([area, price]) => (
                    <tr key={area} className="border-b border-background-200 last:border-b-0">
                      <td className="px-4 py-3 text-foreground-700">{area}</td>
                      <td className="px-4 py-3 text-foreground-950 text-right whitespace-nowrap" style={{ fontFamily: "var(--font-heading)" }}>
                        ¥{price.toLocaleString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-light text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
              お支払い方法
            </h2>
            <div className="space-y-4">
              <div className="border border-background-200 rounded-xl p-5">
                <p className="text-sm text-foreground-900 mb-1" style={{ fontFamily: "var(--font-heading)" }}>
                  銀行振込
                </p>
                <p className="text-sm text-foreground-600" style={{ fontFamily: "var(--font-body)" }}>
                  ご注文確定後、振込先をメールにてご案内します。ご入金確認後7日以内に発送いたします。振込手数料はお客様のご負担となります。
                </p>
              </div>
              <div className="border border-background-200 rounded-xl p-5">
                <p className="text-sm text-foreground-900 mb-1" style={{ fontFamily: "var(--font-heading)" }}>
                  クレジットカード
                </p>
                <p className="text-sm text-foreground-600" style={{ fontFamily: "var(--font-body)" }}>
                  安全な決済システムでその場でお支払いいただけます。ご注文完了後、すぐに発送準備を開始します。
                </p>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
